export const ADD_TODO = 'TODO/ADD';
export const TOGGLE_TODO = 'TODO/TOGGLE';
export const REMOVE_TODO = 'TODO/REMOVE';




// WEBPACK FOOTER //
// ./src/todos/actionTypes.js